(() => {
  if (window.elookusDesktopSelectionBound) return;
  window.elookusDesktopSelectionBound = true;
  let suppressFocusOpen = false;
  const desktop = () => window.matchMedia('(min-width: 768px)').matches;
  const host = () => document.querySelector('#main-nav.elookus-selection-desktop');
  const proxy = () => document.getElementById('proxy-nav');
  const triggers = () => [...(proxy()?.querySelectorAll('.elookus-desktop-trigger') || [])];
  const panelFor = trigger => document.getElementById(trigger.getAttribute('aria-controls'));
  const triggerFor = panel => triggers().find(t => t.getAttribute('aria-controls') === panel?.id);
  const close = (panel, restore = false) => {
    if (!panel) return;
    const nav = host(), item = panel.parentElement, trigger = triggerFor(panel);
    if (nav) clearTimeout(nav.navOpenTimeoutId);
    item.dispatchEvent(new Event('mouseleave'));
    item.classList.remove('navigation__item--show-children');
    item.firstElementChild.setAttribute('aria-expanded', 'false');
    trigger?.setAttribute('aria-expanded', 'false');
    if (restore && trigger) {
      suppressFocusOpen = true;
      trigger.focus();
      suppressFocusOpen = false;
    }
  };
  const closeAll = () => host()?.querySelectorAll('.elookus-desktop-panel').forEach(p => close(p));
  const open = (trigger, focusFirst = false) => {
    const nav = host(), panel = panelFor(trigger);
    if (!desktop() || !nav || !panel) return;
    nav.onProxyNavEnterSmallMenu?.({currentTarget: trigger.parentElement});
    panel.parentElement.dispatchEvent(new Event('mouseenter'));
    trigger.setAttribute('aria-expanded', 'true');
    if (focusFirst) setTimeout(() => panel.querySelector('a')?.focus(), 200);
  };
  document.addEventListener('focusin', event => {
    if (!desktop() || suppressFocusOpen) return;
    const trigger = event.target.closest('#proxy-nav .elookus-desktop-trigger');
    if (trigger) open(trigger);
  });
  document.addEventListener('focusout', () => {
    if (!desktop()) return;
    setTimeout(() => {
      const active = document.activeElement;
      if (!active?.closest('#main-nav.elookus-selection-desktop .elookus-desktop-panel, #proxy-nav .elookus-desktop-shape-item')) closeAll();
    }, 0);
  });
  document.addEventListener('keydown', event => {
    if (!desktop()) return;
    const trigger = event.target.closest('#proxy-nav .elookus-desktop-trigger');
    const panel = event.target.closest('#main-nav.elookus-selection-desktop .elookus-desktop-panel');
    if (trigger && event.key === 'Enter') {
      event.stopPropagation();
    } else if (trigger && event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      document.body.classList.add('tab-used');
      open(trigger, true);
    } else if (event.key === 'Escape' && (trigger || panel)) {
      event.preventDefault();
      event.stopPropagation();
      close(panel || panelFor(trigger), true);
    }
  }, true);
  document.addEventListener('click', event => {
    if (desktop() && !event.target.closest('#main-nav.elookus-selection-desktop .elookus-desktop-panel, #proxy-nav .elookus-desktop-shape-item')) closeAll();
  });
  const observe = () => {
    const nav = host();
    if (!nav) return;
    new MutationObserver(() => {
      triggers().forEach(trigger => {
        const link = panelFor(trigger)?.parentElement.firstElementChild;
        trigger.setAttribute('aria-expanded', link?.getAttribute('aria-expanded') || 'false');
      });
    }).observe(nav, {subtree: true, attributes: true, attributeFilter: ['aria-expanded']});
  };
  observe();
  document.addEventListener('shopify:section:load', observe);
})();
